export default __webpack_public_path__ + "static/media/aequalis10.1bd6a9d4.pdf";